import { render } from "./forgotPasswordForm.vue?vue&type=template&id=7101b060"
import script from "./forgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./forgotPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__